import React, { useEffect, useState } from "react";
import { NavBar, Footer, AnalysisPDF } from "../../components";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import configuration from "../../../package.json";

export const Subjects = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { homepage } = configuration;
  const [items, setItems] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [settings, setSettings] = useState([]);
  const [filesSize, setFilesSize] = useState([]);
  const [downLoadFiles, setDownLoadFiles] = useState(null);
  
  const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
  if (path) {
    navigate.replace(path);
  }

  useEffect(() => {
    getManifest();
  }, [props]);

  
  const getManifest = async () => {
    try {
      // Load settings.json instead of settings.yaml
      const settingsRes = await axios.get(`${homepage}data/settings.json`);
      const settingsData = settingsRes.data; // Direct JSON parsing, no jsyaml needed

      const currentSettings = settingsData.filter((e) => e.lang === "en");
      setSettings(currentSettings);

      // Load manifest.json instead of manifest.yaml
      const manifestRes = await axios.get(`${homepage}data/manifest.json`);
      const { manifest } = manifestRes.data; // Direct JSON parsing

      const stage = Object.keys(currentSettings[0].stage_names).find(
        (key) =>
          currentSettings[0].stage_names[key].toLowerCase() ===
          params.stage?.toLowerCase()
      );
      
      const filteredItems = manifest.items.filter((item) => item.stage == stage);
      setItems(filteredItems);

      const uniqueObjects = [];
      for (const item of filteredItems) {
        const { content, subject } = item;
        const isDuplicate = uniqueObjects.some(
          (obj) => obj.content === content && obj.subject === subject
        );
        if (!isDuplicate) {
          uniqueObjects.push({ content, subject });
        }
      }
      setSubjects(uniqueObjects);
    } catch (error) {
      console.error(error);
    }
  };

  const getFileSizeFromLink = (link, ind) => {
    let mbSize = null;
    if (!filesSize[ind]) {
      axios
        .get(link)
        .then((res) => {
          mbSize = (res.headers["content-length"] / 1024 / 1024).toFixed(2);
          setFilesSize((filesSize) => {
            const newArray = [...filesSize];
            newArray.splice(ind, 1, mbSize);
            return newArray;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <div className="flex w-full max-w-screen h-fit min-h-screen p-0 m-0 flex-col gap-2 overflow-hidden md:max-w-[875px] md:m-auto relative">
      <NavBar
        title={settings[0] ? settings[0].series_names.m : "GPS Education"}
        home={false}
        search={false}
      />
      <div className="grid w-full grid-cols-1 sm:grid-cols-1 px-2 top-16 mt-2 relative gap-4">
        {subjects.map((subjectItem, index) => (
          <div key={index} className="col-span-1">
            <div className="p-2 gap-4 flex flex-col sm:flex-row justify-around">
              <div className="w-full grid grid-cols-1 gap-3">
                <div className="col-span-1 flex w-full flex-col rounded-lg divide-y overflow-hidden">
                  <div className="bg-gray-700 rounded-t-lg text-white text-center p-1 text-xl text-md font-bold">
                    {settings[0]
                      ? settings[0].subject_titles[subjectItem.subject]
                      : subjectItem.subject}{" "}
                  </div>
                  {items
                    .filter(
                      (item) =>
                        item.content === subjectItem.content.toLowerCase() &&
                        item.subject === subjectItem.subject
                    )
                    .map((item, ind) =>
                      <Link
                        key={ind}
                        to={`/dict/${params.stage}/${item.subject.toLowerCase()}/${item.grade}`}
                        title={`Grade ${item.grade}`}
                        className="cursor-pointer text-md font-semibold p-1 px-3 items-center justify-center bg-white hover:bg-gray-50 transition-colors"
                      >
                        {settings[0]
                          ? settings[0].grade_names[item.grade]
                          : `Grade ${item.grade}`}
                      </Link>
                    )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="h-24" />
      <Footer />
    </div>
  );
};